module.exports = __webpack_public_path__ + "img/Certificate.678dd664.jpg";